import { useThemeConfig } from '../model/store/theme-config'
import { useTheme } from 'next-themes'
import { selectThemeConfig } from '../model/selectors/theme'
import { DefaultThemes } from '@/shared/config/theme/lib/theme'

export function useGetThemeMode() {
  const theme = useTheme().theme
  const mode = useThemeConfig(selectThemeConfig)
  const light = mode.light || DefaultThemes['light']
  return theme === light ? 'light' : 'dark'
}
